import { useTranslation } from 'react-i18next';
import { MaintenanceStatus } from '@/services/maintenances-service/maintenances-service.types';
import styles from './maintenance-status-chip.module.scss';

interface MaintenanceStatusChipProps {
  status: string;
}

export default function MaintenanceStatusChip({ status }: MaintenanceStatusChipProps) {
  const { t } = useTranslation('maintenances');
  const normalizedStatus = status.toLowerCase() as MaintenanceStatus;

  return (
    <div
      className={`${styles.status} ${
        normalizedStatus === 'open'
          ? styles.statusOpen
          : normalizedStatus === 'closed'
            ? styles.statusClose
            : styles.statusInProgress
      }`}
    >
      {normalizedStatus === 'open'
        ? t('status.open')
        : normalizedStatus === 'closed'
          ? t('status.closed')
          : t('status.in_progress')}
    </div>
  );
}
